import {Decoration, EditorView, WidgetType} from '@codemirror/view';
import {RangeSet, StateField} from '@codemirror/state';
import {syntaxTree} from '@codemirror/language';

export const imagePreview = () => StateField.define({
  create(state) {
    return widgetsRangeSet(state);
  },
  update(previews, transaction) {
    if (transaction.docChanged) {
      return widgetsRangeSet(transaction.state);
    }
    return previews.map(transaction.changes);
  },
  provide(field) {
    return EditorView.decorations.from(field);
  },
});

function widgetsRangeSet(state) {
  const widgets = [];
  const tree = syntaxTree(state);
  tree.iterate({
    enter(type) {
      const {from, to} = type;
      if (type.name === 'Image') {
        const href = parsedMarkdownHref(state.doc.sliceString(from, to))
        if (href) {
          const position = Math.min(state.doc.lineAt(from).to + 1, state.doc.length);
          widgets.push(previewWidget(href, 0).range(position));
        }
      }
    },
  });
  return widgets.length > 0 ? RangeSet.of(widgets) : Decoration.none;
}

function parsedMarkdownHref(markdown) {
  const result = /!\[.*]\((?<href>.*)\)/.exec(markdown);
  if (result && result.groups && result.groups.href) {
    return result.groups.href;
  }
  return null;
}

function previewWidget(href, side) {
  return Decoration.widget({widget: new PreviewWidget(href), side, block: true});
}

class PreviewWidget extends WidgetType {
  constructor(href) {
    super()
    this.href = href;
  }

  eq(other) {
    return other.href === this.href;
  }

  toDOM() {
    const container = document.createElement('div');
    container.className = 'cm-line-image-preview';
    const image = container.appendChild(document.createElement('img'));
    image.src = this.href;
    return container;
  }
}
